import * as React from "react";
import { IReferenceValue } from "../../../model/form/ReferenceValue";
import { IFormQualifierAttribute } from "../../../model/form/FormQualifierAttribute";
import { IFormInputValue } from "../../../model/form/FormInputValue";
import SelectInput from "../app/SelectInput";
import {
  FormDisplayConstants,
  AttributeFormConstants
} from "../../../common/Constants";
import { Icon, Button } from "antd";

export interface State {
  selectOptions?: IReferenceValue[];
  loading: boolean;
  valueRef2: string;
}

export interface Props {
  attribute: IFormQualifierAttribute;
  translate: any;
  getReferenceValues: any;
  referenceValueList?: IReferenceValue[];
  formInputValue?: IFormInputValue;
  onSelect?: any;
  placeholder?: string;
  onChange: any;
  style?: any;
  formTypeCode: string;
  qualifierCode: string;
  isReference2?: boolean;
}

export default class DisplaySelectField extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selectOptions: this.props.formInputValue && [
        {
          id:
            this.props.formInputValue.valueIdRef === null
              ? AttributeFormConstants.REF_2_DEFAULT_ID
              : this.props.formInputValue.valueIdRef,
          value: this.props.formInputValue.valueRef
        }
      ],
      loading: false,
      valueRef2: ""
    };
  }

  valueIncludeInSelectOptions = (valueIdRef?: any) => {
    const { selectOptions } = this.state;
    const value = (selectOptions || []).find((item) => item.id === valueIdRef);
    return value ? true : false;
  };

  getReferenceValueList = async (
    attributeCode: string,
    formQualifierId: number,
    formTypeCode: string,
    qualifierCode: string,
    formAttributeId: number
  ) => {
    this.setState({
      loading: true
    });
    await this.props.getReferenceValues(
      attributeCode,
      formQualifierId,
      formTypeCode,
      qualifierCode,
      formAttributeId
    );
    this.props.referenceValueList &&
      this.setState({
        selectOptions: this.props.referenceValueList
      });
    this.setState({
      loading: false
    });
  };

  onNameChange = (value: any) => {
    this.setState({
      valueRef2: value
    });
  };

  addItem = () => {
    const { selectOptions, valueRef2 } = this.state;
    this.setState({
      selectOptions: [
        ...selectOptions,
        { id: AttributeFormConstants.REF_2_DEFAULT_ID, value: valueRef2 }
      ]
    });
    this.props.onChange();
  };

  onMouseDown = (e) => {
    e.preventDefault();
    return false;
  };

  render() {
    const {
      attribute,
      translate,
      formInputValue,
      onSelect,
      placeholder,
      onChange,
      style,
      formTypeCode,
      qualifierCode,
      isReference2 = false
    } = this.props;

    const { selectOptions, loading } = this.state;

    const onFocusSelectField = () => {
      formInputValue &&
        this.getReferenceValueList(
          attribute.attributeCode,
          formInputValue.formQualifierId,
          formTypeCode,
          qualifierCode,
          attribute.formAttributeId
        );
    };

    return (
      <SelectInput
        key={attribute.id}
        placeholder={placeholder}
        allowClear
        showSearch={true}
        onSearch={(value: string) => this.onNameChange(value)}
        notFoundContent={
          isReference2 ? (
            <Button onClick={this.addItem} type={"link"}>
              <Icon type={"plus"} /> {translate("select_input.add_btn")}
            </Button>
          ) : (
            translate("search.no_data")
          )
        }
        style={{ width: FormDisplayConstants.COLUMN_WIDTH, ...style }}
        onSelect={onSelect}
        onChange={onChange}
        optionFilterProp={"label"}
        onFocus={() => onFocusSelectField()}
        loading={loading}
        value={
          formInputValue
            ? formInputValue.valueIdRef
              ? formInputValue.valueIdRef
              : formInputValue.valueIdRef === null && formInputValue.valueRef
              ? AttributeFormConstants.REF_2_DEFAULT_ID
              : undefined
            : undefined
        }
        selectOptionKey={"id"}
        selectOptionValue={"value"}
        selectOptions={selectOptions}
      />
    );
  }
}
